import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/random-team-stacking/actions';
import MultiSelect from 'components/atoms/dropdowns/multi-select';

class PositionsGroup extends Component {
    onValuesChange(selectedValues) {
        const {groupNumber} = this.props;

        this.props.dispatch(Action.set('DisallowedPositions', groupNumber, selectedValues));
    }

    getOptions() {
        const {sportConfig} = this.props;
        return Object.values(sportConfig.getPositions()).map((posName) => {
            return {value: posName, label: posName};
        });
    }

    getValues() {
        const {stacking, groupNumber} = this.props;
        const positions = stacking.getDisallowedPositionsByGroupNumber(groupNumber);
        return positions.map((posName) => {
            return {value: posName, label: posName};
        });
    }

    render() {
        const options = this.getOptions();
        const values = this.getValues();

        return (
            <MultiSelect
                onSelect={::this.onValuesChange}
                options={options}
                values={values}
                placeholder={'Select positions'}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {randomTeamStacking, sportConfig} = state;
    return {
        sportConfig,
        stacking: randomTeamStacking,
    };
}

export default connect(mapStatesToProps)(PositionsGroup);
